import SystemFieldProto from '../../proto/system-field-proto';
import mapProject from "../../import/normalize/map-project";
import {PROJECT_PATH_SEPARATOR} from "../../../gd/const/import-export/import-export";

export default class ProjectFullNameField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.PROJECT_FULL_NAME;
    }

    getCsvValue(item) {
        const _collectParentProjectsName = (projectId)=>{
            let res = [];
            const project = gd.session.projects.get(projectId);
            if (project) {
                res.push(project.name);
                if (project.parentId) res = _collectParentProjectsName(project.parentId).concat(res);
            }
            return res;
        };

        // separator has spaces (!) important
        return _collectParentProjectsName(item.projectId).join(PROJECT_PATH_SEPARATOR);
    }

    normalizeCSVValue(value) {
        return mapProject(gd.companyId, null, value);
    }
}